import React from 'react';
import './ExtendedReportCard.scss'
import { Checkbox } from '@material-ui/core';

interface ExtendedReportProps {
    title: string;
    content: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const ExtendedReportCard = ({ title, content, checked, onChange }: ExtendedReportProps) => {

    return (
        <div className='c-content-report-card'>
            <div>
                <Checkbox
                    name={title}
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    onMouseDown={(e) => e.stopPropagation()}
                />
            </div>
            <div className='c-card-info'>
                <h3>{title}</h3>
                <p>{content}</p>
            </div>
        </div>
    )
}

export default ExtendedReportCard